import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, onUnmounted, ref } from 'vue';

import CountdownTimer from '@/components/sponsored-recommendations/actions/CountdownTimer.vue';
import PictureComp from '@/components/picture/PictureComp.vue';

import { SnowplowContext, SnowplowModuleContext } from '@/helpers/tracking/providers/snowplow-contexts';

import type { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import type { PosterSponsoredRecImages } from '@/interfaces/components/poster/PosterGraphql';
import { useCampaignInfo } from '@/components/sponsored-recommendations/useSendBidId';

import { BackgroundImageSize } from '@/@types/graphql-types';
import type { Maybe } from '@/helpers/types';

type ImageObject = { [key in BackgroundImageSize]: string };

export default /*#__PURE__*/_defineComponent({
  __name: 'SponsoredRecommendationPremiumImage',
  props: {
    sponsoredAdCampaign: null,
    lazy: { type: Boolean, default: true },
    additionalContexts: { default: () => [] }
  },
  emits: ["onPosterClickOut", "imageError"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: 'onPosterClickOut'): void;
	(e: 'imageError', src: Maybe<string>): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { sponsoredAdCampaign: NonNullable<SponsoredAdFragment['campaign']>, lazy: boolean, additionalContexts: (SnowplowModuleContext | SnowplowContext)[] };





const { campaignNode, promotionalTitle, promotionalTextWithGenreFallback } = useCampaignInfo(
	() => props.sponsoredAdCampaign
);

const backgroundImages = computed(() => {
	const imageSizes: ImageObject = {} as ImageObject;

	props.sponsoredAdCampaign?.backgroundImages?.map(options => {
		if (!options?.size) {
			return;
		}

		imageSizes[options.size] = options?.imageURL;
	});

	return imageSizes;
});

const getReleaseDate = computed<Date | undefined>(() => {
	if (!process.client || !props.sponsoredAdCampaign?.countdownTimer) return undefined;

	return new Date(props.sponsoredAdCampaign?.countdownTimer);
});

// Title Poster (to support AVIF)
const posterSRImage = computed<PosterSponsoredRecImages | null>(() => {
	let posterUrl = props.sponsoredAdCampaign?.posterOverride || campaignNode?.value.content.posterUrl;
	if (!posterUrl) return null;

	if (posterUrl.startsWith('/')) {
		posterUrl = `${JW_CONFIG.IMAGESCALER_URL}${posterUrl.replace('{profile}', 's332')}`;
	}

	return {
		imageUrl: posterUrl,
		sourceSets: [
			{
				srcSet: posterUrl.replace(/\.{?\w+}?$/, '.avif'),
				imageProp: {
					extension: '.avif',
					type: 'image/avif',
				},
				sourceProp: {
					viewport: 'desktop',
				},
				media: null,
			},
		],
	};
});

// Manage check to display countdown
onMounted(() => checkIfHasTimeRemaining());
onUnmounted(() => clearInterval(timerToMatchStarts));
const timerToMatchStarts = setInterval(checkIfHasTimeRemaining, 1000);

const hasTimeRemaining = ref(true);

function checkIfHasTimeRemaining() {
	// If there is no release time, hide countdown
	if (!process.client || !getReleaseDate.value) {
		hasTimeRemaining.value = false;
		return;
	}

	const currentTime = new Date();

	// If release time is after the currentTime
	if (currentTime.getTime() >= getReleaseDate.value.getTime()) {
		hasTimeRemaining.value = false;
		return;
	}

	hasTimeRemaining.value = true;
}

return { __sfc: true,props, emits, campaignNode, promotionalTitle, promotionalTextWithGenreFallback, backgroundImages, getReleaseDate, posterSRImage, timerToMatchStarts, hasTimeRemaining, checkIfHasTimeRemaining, CountdownTimer, PictureComp }
}

})